// import dayjs from 'dayjs';
import applyMixin from '@/models/mixins/mixin';

export default function (object) {
  applyMixin(object, {
    mutators() {
      return {
        createdAt(value) {
          return value ? new Date(value) : null;
        },
        updatedAt(value) {
          return value ? new Date(value) : null;
        },
      };
    },

    fields() {
      return {
        id: this.attr(),
        createdAt: this.attr(),
        updatedAt: this.attr(),
      };
    },

    get createdAtHumanReadable() {
      // Formats the post time to look like `Monday, 10:15am (4/20/2020)`.
      // TODO: Consider adding relative time.
      // return this.createdAt ? dayjs(this.createdAt).from(dayjs()) : '';
      // return this.createdAt
      //   ? dayjs(this.createdAt).format('dddd, h:mma (MM/DD/YYYY)')
      //   : '';
    },
  });
}
